import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { CreateBuildingSavingsForm } from "web_myplann/Portfolio/Pages/BuildingSavingsCreate/CreateBuildingSavingsForm";
import { PortfolioAddLayout } from "web_myplann/Portfolio/PortfolioShared/PortfolioAddLayout";

export const AddBuildingSavingsPage = () => {
	const { t } = useResource();

	return (
		<PortfolioAddLayout title={t(Resources.Portfolio.AddBuildingSavings.title)}>
			<CreateBuildingSavingsForm />
		</PortfolioAddLayout>
	);
};
